import { Stack } from '@mantine/core';
import { t } from 'i18next';

import { GlobalActivityLogGrid } from 'modules/shared/activityLog/GlobalActivityLogGrid';

export const ActivityLog = () => {
    return (
        <Stack className="card p-xl w-full">
            <div className="text-4xl">{t('activityLog')}</div>
            <GlobalActivityLogGrid />
        </Stack>
    );
};
